import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateCalculationsModal({
  createInput,
  createCalculations,
  formData,
  setFormData,
  getCalculationsList,
  id,
  getCalculationsType,
  calculationsType,
}) {
  const setModal = useContext(ModalContext);

  let validation = {};

  const validateForm = useFormValidator(formData, validation);

  useEffect(() => {
    if (_.get(formData, 'is_multiple')) {
      validation = {
        ...validation,
        multiplier: 'required',
      };
    }
    validateForm.onSetObjectRules(validation);
  }, [_.get(formData, 'is_multiple')]);

  useEffect(() => {
    setFormData({
      ...formData,
      multiplier: '',
    });
  }, [_.get(formData, 'tax_revenue_calculation_type_id')]);

  useEffect(() => {
    getCalculationsType();

    setFormData({
      for_new: 1,
      for_renewal: 1,
      for_retirement: 1,
      multiplier: '',
      with_essential_computation: 0,
      include_for_higher_value_comparison: 0,
    });
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      multiplier: _.get(formData, 'multiplier'),
      tax_revenue_calculation_type_id: parseInt(
        _.get(formData, 'tax_revenue_calculation_type_id'),
        10
      ),
      for_new: _.get(formData, 'for_new') ? 1 : 0,
      for_renewal: _.get(formData, 'for_renewal') ? 1 : 0,
      for_retirement: _.get(formData, 'for_retirement') ? 1 : 0,
      with_essential_computation: _.get(formData, 'with_essential_computation')
        ? 1
        : 0,
      include_for_higher_value_comparison: _.get(
        formData,
        'include_for_higher_value_comparison'
      )
        ? 1
        : 0,
      label: _.get(formData, 'label'),
    };

    createCalculations(id, args, () => {
      setModal({ isOpen: false });
      getCalculationsList(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const selectCalculationsType = (calculationsType || []).map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
    is_multiple: _.get(x, 'attributes.is_multiple'),
  }));

  // const filteredSelectCalculationsTypeOptions = (selectCalculationsType || []).filter(item => item.label !== "Quantity Matrix");

  const handleDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      is_multiple: e ? e.is_multiple : '',
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Calculation Type
            </label>
            <Select
              options={selectCalculationsType}
              placeholder="Select Calculation Type"
              onChange={handleDropDownChange('tax_revenue_calculation_type_id')}
            />
          </div>
          {['12'].indexOf(_.get(formData, 'tax_revenue_calculation_type_id')) > -1 && (
            <div className="col-12 form-group">
              <label className="form-label">
                Label: 
              </label>
              <input
                className="form-control"
                type="text"
                name="label"
                onChange={onChange}
                value={_.get(formData, 'label')}
              />
            </div>
          )}
          <div className="col-12 form-group">
            <input
              name="with_essential_computation"
              type="checkbox"
              checked={_.get(formData, 'with_essential_computation') || 0}
              onChange={onChange}
            />
            <label htmlFor="last_name" className="form-label mx-2 mb-0">
              With Essential Rate
            </label>
          </div>
          <div className="col-12 form-group">
            <input
              name="include_for_higher_value_comparison"
              type="checkbox"
              checked={
                _.get(formData, 'include_for_higher_value_comparison') || 0
              }
              onChange={onChange}
            />
            <label htmlFor="last_name" className="form-label mx-2 mb-0">
              Include For Higher Value Comparison
            </label>
          </div>
          {_.get(formData, 'is_multiple') ? (
            <div className="col-12 form-group">
              <label className="full-label mb-0">
                Multiplier: {validateForm.renderMessage('multiplier')}
              </label>
              <div className="">
                {createInput(
                  { key: 'multiplier' },
                  { placeholder: 'Ex. code_multiplier' }
                )}
              </div>
            </div>
          ) : (
            ' '
          )}
          <div className="col-12">
            <div className="form-group">
              <input
                name="for_new"
                type="checkbox"
                checked={_.get(formData, 'for_new') || 0}
                onChange={onChange}
              />
              <label htmlFor="last_name" className="form-label mx-2 mb-0">
                New
              </label>
            </div>
            <div className="form-group">
              <input
                name="for_renewal"
                type="checkbox"
                checked={_.get(formData, 'for_renewal') || 0}
                onChange={onChange}
              />
              <label htmlFor="last_name" className="form-label mx-2 mb-0">
                Renewal
              </label>
            </div>
            <div className="form-group">
              <input
                name="for_retirement"
                type="checkbox"
                checked={_.get(formData, 'for_retirement') || 0}
                onChange={onChange}
              />
              <label htmlFor="last_name" className="form-label mx-2 mb-0">
                Retirement
              </label>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateCalculationsModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getCalculationsList: PropTypes.instanceOf(Function).isRequired,
  createCalculations: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  getCalculationsType: PropTypes.instanceOf(Function).isRequired,
  calculationsType: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  calculationsType: _.get(api, `${c.GET_CALCULATIONS_TYPE_LICENSE}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateCalculationsModal);
